import { NgModule } from '@angular/core';
import { NbMenuModule, NbPopoverModule } from '@nebular/theme';
import { ThemeModule } from '../@theme/theme.module';
import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages-routing.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { GreetingModule } from '../@core/greeting/greeting.module';
import { DeclarationPromptModule } from '../@core/declaration-prompt/declaration-prompt.module';
import { AiAssistanceModule } from './ai-assistance/ai-assistance.module';
import { AiChatwootBuddyModule } from './ai-chatwoot-buddy/ai-chatwoot-buddy.module';
import { TownhallComponent } from './townhall/townhall.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { GaugeChartModule } from './gauge-chart/gauge-chart.module';

 
@NgModule({
  imports: [
    PagesRoutingModule,
    GreetingModule,
    DeclarationPromptModule,
    ThemeModule,
    NbMenuModule,
    MiscellaneousModule,
    AiAssistanceModule,
    AiChatwootBuddyModule,
    NbPopoverModule,
    NbDateFnsDateModule.forRoot({
      format: 'dd MMM yy'
    }),
    GaugeChartModule,
   
  ],
  declarations: [
    PagesComponent
  ],
})
export class PagesModule {
}
 
 